var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default btn-sm",on:{"click":function($event){return _vm.copyHandler()}}},[_c('i',{staticClass:"fal fa-copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }